/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { INotificationsListViewProps } from '@msdyn365-commerce-modules/notifications-lists';
import { INotificationsListConfig } from '../definition-extensions/notifications-list.ext.props.autogenerated';

let hasChangedB2CCustomerAccessB2BChannelNotAllowedErrorMessage = false;

export const NotificationsListView: React.FC<INotificationsListViewProps> = props => {
    const config = props.config as unknown as INotificationsListConfig;

    if (!hasChangedB2CCustomerAccessB2BChannelNotAllowedErrorMessage) {
        const b2CCustomerAccessB2BChannelNotAllowedErroCode = 'Microsoft_Dynamics_Commerce_Runtime_B2CCustomerAccessB2BChannelNotAllowed';

        if (props.context.request.user.retailServerErrorCode === b2CCustomerAccessB2BChannelNotAllowedErroCode && config.b2CCustomerAccessB2BChannelNotAllowedOverride) {
            props.context.request.user.retailServerErrorMessage = config.b2CCustomerAccessB2BChannelNotAllowedOverride;
            hasChangedB2CCustomerAccessB2BChannelNotAllowedErrorMessage = true;
        }
    }

    return <Module {...props.container}>{props.notificationsList}</Module>;
};

export default NotificationsListView;
